<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Waitlist<span class="offerstatus">{{rowCount|number}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
    <li>Opportunity<span style="padding:8px;">|</span></li>
    <li>Waitlist</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="border-div table-fixed margin-bottom-0">
          <div class="floatinghead clearfix">
            <div class="row">
              <div class="col-sm-12">
                <div class="rightside d-flex clearfix margin-bottom-15 waiting-list-hdr">
                  <div class="search-sec margin-right-10">
                    <input class="form-control" type="text" [(ngModel)]="searchText"  (keyup)="onSearch($event.target.value)" placeholder="Search">
                    <i class="fa fa-search icon" aria-hidden="true"></i>
                  </div>
                  <div class="date-field margin-right-10 ">
                    <div class="form-group d-flex flex-direction-colum">
                      <!--<label class="form-label">Date Range</label>-->
                      <div class="d-flex">
                          <div class="textbox-date margin-right-5">
                            <input class="form-control" [(ngModel)]="dateFromRange" type="text" placeholder="From" placement="bottom right" bsDatepicker>
                            <i class="icofont icofont-ui-calendar icon"></i>
                          </div>
                          <div class="textbox-date">
                            <input class="form-control" [(ngModel)]="dateToRange" type="text" placement="bottom right" placeholder="To" bsDatepicker>
                            <i class="icofont icofont-ui-calendar icon"></i>
                          </div>
                      </div>
                      
                    </div>
                  </div>
                  <button class="btn btn-success btn-lg btn-send-inquiry" (click)="search()"> Search </button>
                  <button class="btn-lg btn-border btn adduserbtn margin-left-10" (click)="Export()"> Export </button>
                </div>
              </div>
            </div>
          </div>



          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th class="min-width-td sticky-left z-100">Principal</th>
                  <th>Company Name</th>
                  <th>Role</th>
                  <th>Joined Date</th>
                  <th>State</th>
                  <th>City</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of userLst;let i = index ">
                  <td class="sticky-left">
                    <p><a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{principal:user.Guid, prevroute:'Waitlist', link : 'waitlist-users'}">{{user.Principal}}</a></p>
                    <p class="whitespacenowrap">{{ user.Phone | phone }}</p>
                    <p class="whitespacenowrap">{{ user.Email }}</p>
                  </td>
                  <td>
                    <p>{{ user.CompanyName ? user.CompanyName:'-' }}</p>
                  </td>
                  <td>
                    <p class="whitespacenowrap">{{ user.Role }}</p>
                  </td>
                  <td>
                    <p>{{ user.JoinedDate ? (Validation.convertUTCDateToLocalDate(user.JoinedDate)| date:'MM/dd/yyyy') :'-' }}</p>
                  </td>
                  <td>
                    <p>{{ user.State ?  user.State :'-' }}</p>
                  </td>
                  <td>
                    <p>{{ user.City ?  user.City :'-' }}</p>
                  </td>

                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="userLst?.length == 0 &&!IsLoading">
                  <td colspan="8" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
